import { css } from 'linaria';

export const metalRoofCharasteristicsCollapse = css`
  @media (--only-tablet) {
    min-height: 590px;
  }

  @media (--only-mobile) {
    min-height: 472px;
  }
`;

export const metalRoofCharasteristicsShowMoreBtn = css`
  && {
    @media (--from-desktop) {
      display: none;
    }

    @media (--only-tablet) {
      top: -50px;
      height: 80px;
    }

    @media (--only-mobile) {
      height: 100px;
    }
  }
`;

export const metalRoofCharasteristicsRowWrapper = css`
  &:nth-child(1) {
    div {
      padding-top: 0;
    }
  }
`;

export const metalRoofCharasteristicsRow = css`
  display: flex;
  padding: 20px 0;

  @media (--only-mobile) {
    flex-direction: column;
    gap: 8px;
    padding: 10px 0;
  }
`;

export const metalRoofCharasteristicsColumn = css`
  width: 50%;

  @media (--only-mobile) {
    width: 100%;
  }
`;
